/**
 * @fileoverview gRPC-Web generated client stub for core.private.plans
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";

import {
  DeletePlanRequest,
  DeletePlanResponse} from "./plans_pb";

export class PlansServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoDeletePlan = new grpcWeb.AbstractClientBase.MethodInfo(
    DeletePlanResponse,
    (request: DeletePlanRequest) => {
      return request.serializeBinary();
    },
    DeletePlanResponse.deserializeBinary
  );

  deletePlan(
    request: DeletePlanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DeletePlanResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/core.private.plans.PlansService/DeletePlan",
      request,
      metadata || {},
      this.methodInfoDeletePlan,
      callback);
  }

}

